import { createServerFn } from "@tanstack/react-start";
import type { UserWorkspacesResponse } from "@/lib/api/generated";
import {
  listUserWorkspacesApiUsersMeWorkspacesGet,
  updateLastWorkspaceApiUsersMeLastWorkspacePatch,
} from "@/lib/api/generated/users/users";
import { logInfo, logError } from "@/lib/structured-log";

/**
 * 获取当前用户所有可访问的 workspaces
 */
export const getUserWorkspacesServer = createServerFn({ method: "GET" }).handler(async () => {
  logInfo("user_workspaces.list.server_fn_called", {});

  const response = await listUserWorkspacesApiUsersMeWorkspacesGet();

  if (response.status !== 200) {
    logError("user_workspaces.list.failed", {
      status: response.status,
    });
    throw new Error("Failed to load user workspaces");
  }

  return response.data as UserWorkspacesResponse;
});

/**
 * 更新用户上次访问的 workspace
 */
export const updateLastWorkspaceServer = createServerFn({ method: "POST" })
  .validator((data: { workspaceId: string }) => data)
  .handler(async ({ data }) => {
    logInfo("user_workspaces.update_last.server_fn_called", {
      workspaceId: data.workspaceId,
    });

    const response = await updateLastWorkspaceApiUsersMeLastWorkspacePatch({
      workspace_id: data.workspaceId,
    });

    if (response.status !== 204) {
      logError("user_workspaces.update_last.failed", {
        status: response.status,
        workspaceId: data.workspaceId,
      });
      // 静默失败，不抛出异常
    }
  });
